// extracted by mini-css-extract-plugin
export default {"container":"Frame_container__QEEXb","content":"Frame_content__2EtM4"};